import { TaskCategoryTaskType } from '@urbanx/agx.activities.client'
import {
  IconTaskType,
  IconTaskTypes,
  SelectChipOption,
} from '@urbanx/agx.ui-components2'

const taskIconMap: Partial<Record<TaskCategoryTaskType, IconTaskType>> = {
  // Agreement compliance
  [TaskCategoryTaskType.AgreementDetails]: IconTaskTypes.AgreementCompliance,
  [TaskCategoryTaskType.AgreementComplianceType]: IconTaskTypes.AgreementCompliance,
  [TaskCategoryTaskType.AgreementCommission]: IconTaskTypes.AgreementCompliance,
  // Campaign
  [TaskCategoryTaskType.NewListing]: IconTaskTypes.NewListing,
  [TaskCategoryTaskType.PreLaunch]: IconTaskTypes.Launch,
  [TaskCategoryTaskType.Launch]: IconTaskTypes.Launch,
  [TaskCategoryTaskType.Withdrawn]: IconTaskTypes.Withdrawn,
  [TaskCategoryTaskType.WithdrawnPayments]: IconTaskTypes.Withdrawn,
  [TaskCategoryTaskType.WithdrawnPaymentsReview]: IconTaskTypes.Withdrawn,
  [TaskCategoryTaskType.VendorBankDetailsWithdrawn]: IconTaskTypes.Withdrawn,
  // Property information
  [TaskCategoryTaskType.TenancyPreparationAgencyManaged]: IconTaskTypes.Tenanted,
  [TaskCategoryTaskType.TenancyPreparationSelfManaged]: IconTaskTypes.Tenanted,
  [TaskCategoryTaskType.TenancyInformation]: IconTaskTypes.Tenanted,
  [TaskCategoryTaskType.DateOfLastRentIncrease]: IconTaskTypes.Tenanted,
  [TaskCategoryTaskType.SellerDisclosureVendorSolicitorPreparation]:
    IconTaskTypes.SellerDisclosure,
  [TaskCategoryTaskType.SellerDisclosureUpload]: IconTaskTypes.SellerDisclosure,
  [TaskCategoryTaskType.OwnerBuilderPreparation]: IconTaskTypes.OwnerBuilder,
  [TaskCategoryTaskType.OwnerBuilderDeclarationUpload]: IconTaskTypes.OwnerBuilder,
  [TaskCategoryTaskType.HolidayRental]: IconTaskTypes.HolidayRental,
  [TaskCategoryTaskType.DeceasedEstateJointTenants]: IconTaskTypes.DeceasedEstate,
  [TaskCategoryTaskType.DeceasedEstateTenantsInCommon]: IconTaskTypes.DeceasedEstate,
  [TaskCategoryTaskType.DeceasedEstateSoleOwner]: IconTaskTypes.DeceasedEstate,
  [TaskCategoryTaskType.VpaSpreadsheet]: IconTaskTypes.FollowupMarketingfunds,
  // Contract compliance
  [TaskCategoryTaskType.GeneralContractCompliance]: IconTaskTypes.AgreementCompliance,
  [TaskCategoryTaskType.ContractSpecialConditions]: IconTaskTypes.Conditions,
  [TaskCategoryTaskType.SpecialCondition]: IconTaskTypes.Conditions,
  [TaskCategoryTaskType.ContractOffer]: IconTaskTypes.NewContract,
  [TaskCategoryTaskType.ContractParticulars]: IconTaskTypes.NewContract,
  [TaskCategoryTaskType.ContractPreparation]: IconTaskTypes.NewContract,
  [TaskCategoryTaskType.NewContract]: IconTaskTypes.NewContract,
  [TaskCategoryTaskType.ContractReview]: IconTaskTypes.Review,
  // Exchange
  [TaskCategoryTaskType.SolicitorExchangeInformation]: IconTaskTypes.AwaitingExchange,
  [TaskCategoryTaskType.SolicitorExchangeContractDates]: IconTaskTypes.AwaitingExchange,
  [TaskCategoryTaskType.AgentExchangeInformation]: IconTaskTypes.AwaitingExchange,
  [TaskCategoryTaskType.AgentExchangeContractDates]: IconTaskTypes.AwaitingExchange,
  [TaskCategoryTaskType.ContractExchangeInformation]: IconTaskTypes.AwaitingExchange,
  [TaskCategoryTaskType.ContractExchangeContractDates]: IconTaskTypes.AwaitingExchange,
  [TaskCategoryTaskType.CreateBuyerContactInCrm]: IconTaskTypes.AwaitingExchange,
  // Conditions
  [TaskCategoryTaskType.CoolingOffPeriod]: IconTaskTypes.ConditionDue,
  [TaskCategoryTaskType.FinanceDue]: IconTaskTypes.ConditionDue,
  [TaskCategoryTaskType.BuildingAndPestDue]: IconTaskTypes.ConditionDue,
  [TaskCategoryTaskType.BodyCorporateDue]: IconTaskTypes.BodyCorporate,
  [TaskCategoryTaskType.Unconditional]: IconTaskTypes.Unconditional,
  [TaskCategoryTaskType.UnconditionalVpaReview]: IconTaskTypes.Unconditional,
  // Deposits
  [TaskCategoryTaskType.InitialDeposit]: IconTaskTypes.InitialDeposit,
  [TaskCategoryTaskType.BalanceDeposit]: IconTaskTypes.BalanceDeposit,
  [TaskCategoryTaskType.EarlyReleaseOfDeposit]: IconTaskTypes.Deposit,
  [TaskCategoryTaskType.DepositExceeds10Percent]: IconTaskTypes.DepositExceeds,
  // Settlement
  [TaskCategoryTaskType.Settlement]: IconTaskTypes.Settlement,
  [TaskCategoryTaskType.SettlementPaymentsReview]: IconTaskTypes.Settlement,
  [TaskCategoryTaskType.SettlementPayments]: IconTaskTypes.ApproveSettlementTransfers,
  [TaskCategoryTaskType.VendorBankDetailsSettlement]: IconTaskTypes.Settlement,
  // Termination
  [TaskCategoryTaskType.Termination]: IconTaskTypes.Terminate,
  [TaskCategoryTaskType.TerminationPayments]: IconTaskTypes.Terminate,
  [TaskCategoryTaskType.TerminationPaymentsReview]: IconTaskTypes.Terminate,
  [TaskCategoryTaskType.VendorBankDetailsTermination]: IconTaskTypes.Terminate,
  [TaskCategoryTaskType.BuyerBankDetailsTermination]: IconTaskTypes.Terminate,
  // Commission / invoicing follow-ups
  [TaskCategoryTaskType.CommissionShortfall]: IconTaskTypes.FollowupMarketingfunds,
  [TaskCategoryTaskType.VendorChoiceCommission]: IconTaskTypes.FollowupMarketingfunds,
  [TaskCategoryTaskType.ReferralAgentConjunctionInvoice]:
    IconTaskTypes.FollowupOutstandingContractInformation,
}

export const mapTaskTypeToIconType = (
  taskType?: TaskCategoryTaskType,
  fallback: IconTaskType = IconTaskTypes.NewListing
): IconTaskType => taskIconMap[taskType as TaskCategoryTaskType] ?? fallback

export type AssignTaskHandler = (payload: {
  taskId?: string
  userId?: string
}) => void

export type ToggleTaskStepsHandler = (payload: {
  taskId?: string
  stepIds: number[]
}) => void

export type AssigneeOption = SelectChipOption
